import { EuiSpacer } from '@elastic/eui';
import VideoCard from "../../../../src/components/Motion_Detection/Videos/video-synology-add-camera";
import * as React from 'react';
export default {
  EuiSpacer,
  VideoCard,
  React
};